module.exports = __webpack_public_path__ + "static/img/luxiang.6b595418.svg";